import { Component, OnInit, ViewEncapsulation, Inject, Output, EventEmitter } from '@angular/core';
import { FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { CurrencyFormatterPipe } from '../pipes/currency-formatter.pipe';
import { CurrencyFormater } from 'src/app/receiving/shared/pipe/currency-formater.pipe';


@Component({
    selector: 'app-popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, NgClass, MatFormField, MatLabel, MatSelect, ReactiveFormsModule, MatOption, MatCheckbox, FormsModule, MatDialogActions, MatButton, MatDialogClose, TranslateModule,CurrencyFormatterPipe, CurrencyFormater]
})
export class PopupComponent implements OnInit {
public dialogContent: any;
@Output() confirmClick: EventEmitter<any> = new EventEmitter();
  selectedApproverData: any = null;
  approverFormControl: any;
  selectedReturnUserData: any = null;
  returnUserFormControl: any;
  disableSendMailCheckbox: boolean = false;
  constructor( @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<PopupComponent>) {
    this.dialogContent = data;
    this.disableSendMailCheckbox = !this.dialogContent.sendEmailCheckboxEnable;
  }

  close() {
    this.dialogRef.close();
  }
  ngOnInit() {
    console.log('this.dialogContent.cancel ', this.dialogContent.cancel);
    if(this.dialogContent?.approverList?.length > 0) {
      this.approverFormControl = new FormControl(this.dialogContent.approverList[0]?.key);
      this.selectedApproverData = this.dialogContent?.approverList[0]?.key;
    }
    if(this.dialogContent?.returnUserList?.length > 0) {
      this.returnUserFormControl = new FormControl(this.dialogContent.returnUserList[0]?.key);
      this.selectedReturnUserData = this.dialogContent?.returnUserList[0]?.key;
    }
  }

  selectedApprover(event) {
    this.selectedApproverData = event;
  }

  selectedReturnUser(event) {
    this.selectedReturnUserData = event;
  }

  confirm(event) {
    if(this.dialogContent?.approvalDropdownEnable) {
      this.dialogContent.confirmClick.emit({confirm: event.toLowerCase() , selectedApprover: this.selectedApproverData});
    } else {
      this.dialogContent.confirmClick.emit(event);
    }

  }

}
